// extracted by mini-css-extract-plugin
export default {"vacation":"vacation--d2edF","projectTime":"projectTime--HnWx7"};